<section class="card grid-card" aria-labelledby="partner-invoices-heading">
  <h2 id="partner-invoices-heading">Partner invoices</h2>
  <p class="muted">Load invoices for a single partner. Download links open in a new tab when available.</p>

  <div *ngIf="errorMessage" class="alert alert-error" role="alert">
    {{ errorMessage }}
  </div>

  <div class="toolbar">
    <ng-container *ngIf="partners.length > 0; else manualId">
      <div class="field field-grow">
        <label for="partner-select">Partner</label>
        <select
          id="partner-select"
          class="input"
          [(ngModel)]="selectedPartnerId"
          [disabled]="loading">
          <option *ngFor="let p of partners" [ngValue]="p.id">
            {{ p.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <ng-template #manualId>
      <div class="field field-grow">
        <label for="partner-id-input">Partner ID</label>
        <input
          id="partner-id-input"
          type="text"
          class="input"
          [(ngModel)]="manualPartnerId"
          [disabled]="loading"
          autocomplete="off"
          placeholder="Paste partner GUID" />
      </div>
    </ng-template>
    <div class="field field-action">
      <button
        type="button"
        class="btn-secondary"
        (click)="loadInvoices()"
        [disabled]="loading">
        {{ loading ? 'Loading…' : 'Load invoices' }}
      </button>
    </div>
  </div>

  <p *ngIf="!loading && invoices.length === 0 && !errorMessage" class="hint">
    Choose a partner and tap <strong>Load invoices</strong>.
  </p>

  <!-- Desktop table -->
  <div class="table-wrap" *ngIf="invoices.length > 0">
    <table class="invoice-table" aria-label="Partner invoices">
      <thead>
        <tr>
          <th>Invoice date</th>
          <th>Billing period</th>
          <th>Status</th>
          <th class="num">Transactions</th>
          <th class="num">Amount due</th>
          <th class="num">Total</th>
          <th>References</th>
          <th>Download</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of invoices">
          <td>{{ row.invoiceDate | date: 'dd/MM/yyyy':'Asia/Kolkata' }}</td>
          <td class="billing-period">
            {{ row.billingPeriodStart | date: 'dd/MM/yyyy':'UTC' }} —
            {{ row.billingPeriodEnd | date: 'dd/MM/yyyy':'UTC' }}
          </td>
          <td>{{ row.status || '—' }}</td>
          <td class="num">{{ row.transactionCount }}</td>
          <td class="num">{{ row.amountDue | number: '1.2-2':'en-IN' }}</td>
          <td class="num">{{ row.totalAmount | number: '1.2-2':'en-IN' }}</td>
          <td class="refs">{{ referencesText(row.redemptionReferences) }}</td>
          <td>
            <a
              *ngIf="row.invoiceDownloadUrl; else noLink"
              class="link"
              [href]="row.invoiceDownloadUrl"
              target="_blank"
              rel="noopener noreferrer">
              PDF
            </a>
            <ng-template #noLink>—</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile cards -->
  <div class="invoice-cards" *ngIf="invoices.length > 0">
    <article class="invoice-card" *ngFor="let row of invoices">
      <header class="card-head">
        <span class="card-title">{{ row.invoiceDate | date: 'dd/MM/yyyy':'Asia/Kolkata' }}</span>
        <span class="badge" *ngIf="row.status">{{ row.status }}</span>
      </header>
      <div class="card-body">
        <div class="kv">
          <span class="k">Billing</span>
          <span class="v"
            >{{ row.billingPeriodStart | date: 'shortDate' }} —
            {{ row.billingPeriodEnd | date: 'shortDate' }}</span
          >
        </div>
        <div class="kv">
          <span class="k">Transactions</span>
          <span class="v">{{ row.transactionCount }}</span>
        </div>
        <div class="kv">
          <span class="k">Amount due</span>
          <span class="v num">{{ row.amountDue | number: '1.2-2':'en-IN' }}</span>
        </div>
        <div class="kv">
          <span class="k">Total</span>
          <span class="v num">{{ row.totalAmount | number: '1.2-2':'en-IN' }}</span>
        </div>
        <div class="kv" *ngIf="row.redemptionReferences?.length">
          <span class="k">References</span>
          <span class="v">{{ referencesText(row.redemptionReferences) }}</span>
        </div>
      </div>
      <footer class="card-foot" *ngIf="row.invoiceDownloadUrl">
        <a
          class="btn-link"
          [href]="row.invoiceDownloadUrl"
          target="_blank"
          rel="noopener noreferrer">
          Download invoice
        </a>
      </footer>
    </article>
  </div>
</section>
